import Swal from "sweetalert2";
import React, {useState} from "react";
import logo from "../assets/images/payprologo.png";


const DeactiveAccount = () => {
        const [value,setValue] = useState("")
    const handleSubmit  = async (e) => {
        e.preventDefault();
        await Swal.fire({
            icon: "success",
            title: "Your request has been received" ,
            showConfirmButton: false,
            timer: 2000
        });
        setValue("")
    }
    return (
        <div className="w-full h-screen  flex items-center justify-center ">
            <div
                className="w-full h-full p-3    flex-col flex items-center justify-center  bg-gray-900  shadow-2xl   ">
                <div className='w-full flex pb-10 items-center justify-center'>
                    <img className='w-2/6 bg-white' src={logo} alt={logo} />
                </div>
                <h2 className="mx-auto max-w-2xl text-center text-3xl font-bold tracking-tight text-white sm:text-4xl">Kindly add email to remove your account
                </h2>



                <form className="mx-auto mt-10 flex w-xl gap-x-4">

                    <label htmlFor="email-address" className="sr-only">Email address</label>
                    <input id="email-address" name="email" type="email" autoComplete="email" required=""
                           onChange={(e) => setValue(e.target.value)}
                           value={value}
                           className="min-w-0 flex-auto rounded-md border-0 bg-white/5 px-3.5 py-2 text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-white sm:text-sm sm:leading-6"
                           placeholder="Enter your email"/>

                    <button onClick={handleSubmit}
                            className="flex-none rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white">
                        Proceed to Remove
                    </button>
                </form>



            </div>
        </div>
    )
}

export default DeactiveAccount